import type { UrlEntry, UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<'fullApply', Record<UrlRegion, UrlEntry>> = {
  fullApply: {
    de: 'bewerben2',
    'de-en': 'apply2',
    es: 'solicitar-plaza2',
    'es-en': 'apply2',
    fr: 'inscription2',
    'fr-en': 'apply2',
    gb: 'apply2',
    nl: 'aanmelden2',
    'nl-en': 'apply2',
    pt: 'inscrever2',
    'pt-en': 'apply2',
    us: 'apply2',
    ww: 'apply2',
  },
};
